import React, { Component } from "react";
import FormInputs from "../../components/UI/FormInputs";
import Buttons from "../../components/UI/Buttons";
import TableGrid from "../../components/UI/TableGrid";
import { isSet, toQueryString } from "../../utils/commonUtils";
import WithRoutify from "../../hoc/WithRoutify";
import withReduxState from "../../hoc/wReduxState";
import WithRouter from "../../hoc/WithRouter";
import TableSkeleton from "../../hoc/TableSkeleton";
import PERMISSIONS from "../../utils/AclPermissions";
import DataPermissionTemplateService from "../../services/DataPermissionTemplateService";
import AddDataPermissionTemplate from "./AddDataPermissionTemplate";

class DataPermissionTemplateList extends Component {
  constructor(props) {
    super(props);
    const tableHeaders = [
      {
        label: "",
        key: "isActive",
        type: "checkBox",
        changeHandler: () => {},
      },
      {
        label: "Template Name",
        key: "template_name",
        type: "",
        inputType: "TextInput",
        sortName: "template_name",
      },
      {
        label: "Description",
        key: "description",
        type: "",
        inputType: "TextInput",
      },
      {
        label: "Active",
        key: "is_active_label",
        type: "",
        inputType: "TextInput",
      },
      { label: "Action", key: "action", type: "Actions" },
    ];
    this.state = {
      filters: {
        search_query: "",
      },
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          status: 200,
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "template_name",
          sort_order: "asc",
          search: {},
        },
      },
      formDataInEdit: {},
      activeEditId: null,
      cloneSourceId: null,
      isModelOpen: false,
    };
  }

  componentDidMount() {
    this.fetchList();
  }

  addFormHandler = (isedit = false) => {
    if (isedit) {
      this.setState({ isModelOpen: !this.state.isModelOpen });
    } else {
      this.setState({
        isModelOpen: !this.state.isModelOpen,
        formDataInEdit: {},
        activeEditId: "",
        cloneSourceId: null,
      });
    }
  };

  openEditModal = (rowId) => {
    this.setState({
      formDataInEdit: {},
      activeEditId: rowId,
      cloneSourceId: null,
      isModelOpen: true,
    });
  };

  openCloneModal = (rowId) => {
    this.setState({
      formDataInEdit: {},
      activeEditId: "",
      cloneSourceId: rowId,
      isModelOpen: true,
    });
  };

  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val,
      },
    });
  };

  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      search: filters,
    };
    this.fetchList(queryfilters);
  };

  clearFiltersHandler = async () => {
    await this.setState({
      filters: {},
    });
    this.submitFiltersHandler();
  };

  fetchList = async (query = {}) => {
    const { tableRecords } = this.state;
    try {
      const queryString = toQueryString({
        ...tableRecords.pagination,
        ...query,
      });
      this.props.Loader(true);
      const response = await DataPermissionTemplateService.getList(queryString);

      const rows = response?.data?.data ?? [];
      const tableData = rows.map((data, idx) => {
        const desc = isSet(data.description, "");
        const shortDesc =
          desc.length > 80 ? `${desc.slice(0, 80)}…` : desc;
        return {
          companyIndex: idx,
          isHeading: false,
          rowId: data.data_permission_template_id,
          data: {
            isActive: false,
            template_name: data.template_name,
            description: shortDesc || "—",
            is_active_label: data.is_active ? "Yes" : "No",
            action: [
              {
                className: "btn btn-icon btn-transparent-dark",
                iconType: "Search",
                title: "Edit",
                type: "GridEdit",
                acl: PERMISSIONS.DATA_PERMISSION_TEMPLATE.EDIT,
                clickHandler: () =>
                  this.openEditModal(data.data_permission_template_id),
              },
              {
                className: "btn btn-icon btn-transparent-dark",
                iconType: "Copyicon",
                title: "Clone",
                acl: PERMISSIONS.DATA_PERMISSION_TEMPLATE.CREATE,
                clickHandler: () =>
                  this.openCloneModal(data.data_permission_template_id),
              },
              {
                className: "btn btn-icon btn-transparent-dark",
                iconType: "Remove",
                acl: PERMISSIONS.DATA_PERMISSION_TEMPLATE.DELETE,
                title: "Delete",
                isDelete: true,
                clickHandler: () =>
                  this.deleteHandler(data.data_permission_template_id),
              },
            ],
          },
        };
      });

      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableRows: {
            type: "default",
            status: 200,
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: response?.data?.total,
          },
        },
      }));
    } catch (err) {
      this.setState({
        tableRecords: {
          ...tableRecords,
          tableRows: {
            ...tableRecords.tableRows,
            status: 200,
          },
        },
      });
      console.log(err);
    } finally {
      this.props.Loader(false);
    }
  };

  deleteHandler = async (id) => {
    try {
      this.props.Loader(true);
      DataPermissionTemplateService.deleteTemplate(id)
        .then(() => {
          this.fetchList();
          this.props.Toast.success("Template deleted successfully");
        })
        .catch(() => {})
        .finally(() => {
          this.props.Loader(false);
        });
    } catch (err) {
      console.log(err);
      this.props.Loader(false);
    }
  };

  render() {
    const {
      tableRecords,
      formDataInEdit,
      filters,
      isModelOpen,
      activeEditId,
      cloneSourceId,
    } = this.state;
    const modalTitlePrefix = activeEditId
      ? "Edit"
      : cloneSourceId
        ? "Clone"
        : "Add";
    return (
      <>
        {isModelOpen ? (
          <AddDataPermissionTemplate
            modelTitle={`${modalTitlePrefix} Data Permission Template`}
            isOpen={this.state.isModelOpen}
            fetchList={this.fetchList}
            addFormHandler={this.addFormHandler}
            activeEditId={activeEditId}
            cloneSourceId={cloneSourceId}
            Loader={this.props.Loader}
            formDataInEdit={formDataInEdit}
          />
        ) : null}

        <TableSkeleton
          tableRecords={tableRecords}
          addFormHandler={this.addFormHandler}
          acl={PERMISSIONS.DATA_PERMISSION_TEMPLATE.LIST}
          content={"Data Permission Template List"}
        >
          <div className="sh_cardBox sh_cardbglight">
            <div className="sh_cardHeader">
              <div className="form-group d-flex mb-0 justify-content-between align-items-center formheader">
                <h6 className="text-lg f-500 mb-0">
                  Data permission template configuration
                </h6>
                <div className="d-flex">
                  <div className="form-group-fields row mr-2">
                    <div className="col-12 px-1 d-flex">
                      <div className="input-group input-group-joined input-group-solid">
                        <FormInputs
                          placeholder="Search"
                          value={filters["search_query"]}
                          changeHandler={(val) =>
                            this.onChangeFiltersHandler("search_query", val)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="btn-group pl-2">
                        <button
                          className="btn btn-primary"
                          onClick={() => this.submitFiltersHandler()}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-outline-secondary"
                          onClick={() => this.clearFiltersHandler()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="addAction">
                    <div className="btn-group">
                      <Buttons
                        clickHandler={() => {
                          this.addFormHandler();
                          this.setState({
                            activeEditId: "",
                            cloneSourceId: null,
                          });
                        }}
                        className="btn btn-primary"
                        acl={PERMISSIONS.DATA_PERMISSION_TEMPLATE.CREATE}
                        label={"Add"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sh_cardBody p-0">
              <TableGrid
                addFormHandler={() => this.addFormHandler()}
                hasPagination={true}
                fetchTableRecords={(f) => this.fetchList(f)}
                {...tableRecords}
              />
            </div>
          </div>
        </TableSkeleton>
      </>
    );
  }
}

export default WithRouter(
  withReduxState(WithRoutify(DataPermissionTemplateList))
);
